/**
 * Duplicate Task Operation
 * Creates a copy of an existing task with offset position
 */
import { generateTaskId } from '../utils';

export const createDuplicateTaskHandler = (setLocalSprint, recordAction) => {
  return (task) => {
    const newTaskId = generateTaskId();
    const now = new Date().toISOString();
    const newTask = {
      ...task,
      id: newTaskId,
      name: `${task.name} (copy)`,
      x: (task.x || 0) + 50,
      y: (task.y || 0) + 50,
      // Reset date fields for duplicated task
      createdAt: now,
      updatedAt: now,
      startedAt: null,
      completedAt: null,
      // Keep estimate but clear due date
      dueDate: null,
    };

    setLocalSprint(prev => {
      if (!prev) return prev;
      return { ...prev, tasks: [...prev.tasks, newTask] };
    });

    // Record for undo
    if (recordAction) {
      recordAction({
        type: 'DUPLICATE_TASK',
        description: `Duplicate: "${task.name}"`,
        undo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return { ...prev, tasks: prev.tasks.filter(t => t.id !== newTaskId) };
          });
        },
        redo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return { ...prev, tasks: [...prev.tasks, newTask] };
          });
        },
      });
    }

    return newTaskId;
  };
};
